import { render, staticRenderFns } from "./mainFormOrder.vue?vue&type=template&id=64186a8a&"
import script from "./mainFormOrder.vue?vue&type=script&lang=js&"
export * from "./mainFormOrder.vue?vue&type=script&lang=js&"
import style0 from "./mainFormOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports